import {ContentPeerChannelType} from "../../../redux/Content/PeerChannel/types";

export type ChannelCapability = 'stats' | 'comments' | 'messaging' | 'history';

/**
 * The capabilities the network withholds for this channel, as the connector
 * reported them — only an explicit false counts. null/absent means "not
 * reported" and is treated as available, as it always was, so no existing
 * channel changes.
 */
export const unavailableCapabilities = (channel: ContentPeerChannelType): ChannelCapability[] => {
    const flags: Array<[ChannelCapability, boolean | null | undefined]> = [
        ['stats', channel.statsAvailable],
        ['comments', channel.commentsAvailable],
        ['messaging', channel.messagingAvailable],
        ['history', channel.historyAvailable],
    ];

    return flags.filter(([, available]) => available === false).map(([key]) => key);
};
